/**
 * @generated SignedSource<<4c2630aa9153c6ac3df00e2f67b7e6ab>>
 * @relayHash 75479c019cf9bb00572183ba29df8788
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 75479c019cf9bb00572183ba29df8788

import { ConcreteRequest } from 'relay-runtime';
export type Country = "CH" | "DE";
export type useMedicalRecordSharedWithMeChangedSubscription$variables = Record<PropertyKey, never>;
export type useMedicalRecordSharedWithMeChangedSubscription$data = {
  readonly medicalRecordSharedWithMeChanged: {
    readonly patient: {
      readonly country: Country;
      readonly firstName: string;
      readonly id: string;
      readonly lastName: string;
    };
    readonly requestorUserName: string;
    readonly temporaryNote: string | null;
    readonly userNameToShared: string;
    readonly waitingRoomAppointmentId: string | null;
  };
};
export type useMedicalRecordSharedWithMeChangedSubscription = {
  response: useMedicalRecordSharedWithMeChangedSubscription$data;
  variables: useMedicalRecordSharedWithMeChangedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requestorUserName",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userNameToShared",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "waitingRoomAppointmentId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "temporaryNote",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "country",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useMedicalRecordSharedWithMeChangedSubscription",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SharedMedicalRecordInformation",
        "kind": "LinkedField",
        "name": "medicalRecordSharedWithMeChanged",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "patient",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useMedicalRecordSharedWithMeChangedSubscription",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SharedMedicalRecordInformation",
        "kind": "LinkedField",
        "name": "medicalRecordSharedWithMeChanged",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "patient",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "75479c019cf9bb00572183ba29df8788",
    "metadata": {},
    "name": "useMedicalRecordSharedWithMeChangedSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "45afe77c2e50deca3fa3b72605a87881";

export default node;
